module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin24-300245985745f9611c7f43ff7056c5a8.jpg";